const user = JSON.parse(localStorage.getItem("user"));
export const Authorize = (role) => {
  if (user?.role === role) return true;
  else return false;
};
export const permit = (permission) => {
  return user.permissions.some((item) => item.name === permission);
};
